/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
$(function() { // Shorthand for $( document ).ready()
	// executes when HTML-Document is loaded and DOM is ready

	//menu toggle
	function pushyOn() {
		$("#top-nav").css('z-index', 'auto');
		$("body").addClass("pushy-open-right");
		//remove tabindex for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).removeAttr('tabindex');
		});
	}
	function pushyOff() {
		$("#top-nav").removeAttr("style");
		$("body").removeClass("pushy-open-right");
		//add tabindex=-1 for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).attr('tabindex', '-1');
		});
	}
	$("#mobile-nav").click(function () {
		pushyOn();
	});
	$(".pushy-link, .site-overlay").click(function () {
		pushyOff();
	});
	pushyOff();

	//track phone number taps & clicks
	$('.tel').on('click', function(e){
		e.preventDefault();
		trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
		window.location = $(this).attr("href");
	});

	//hide pushy scrollbar
	$scrollbarWidth = getScrollbarWidth();
	$(".pushy").css('margin-right', '-'+$scrollbarWidth+'px');

	//animate the scroll to top
	addScrollToOnClick('.back2top', 'body', 500);

	//Check for dropdowns when mobile menu toggle is visible then disable the anchor link for the parent li
	/*$("#main-nav > li > a").click(function() {
		try {
			if ($(this).parent().hasClass("has-children") && $("#menu").is(":visible")) {
				return false;
			}
		} catch (e) {
			//console.log(e);
			return false;
		}
	});*/

	//search box dropout effect
	$(".search").click(function() {
		if ($('.search-box').hasClass("search-block")) {
			$('.search-box').removeClass("search-block");
		} else {
			$('.search-box').addClass("search-block");
			$("#q").focus();
		}
	});

	//decrypt encrypted mailto links
	$('.mailto').each(function() {
		var strEncrypted = $(this).html();
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).html(html);
	});

	$(".megamenu").accessibleMegaMenu({
		uuidPrefix: "accessible-megamenu",
		menuClass: "nav-menu",
		topNavItemClass: "nav-item",
		panelClass: "sub-nav",
		panelGroupClass: "sub-nav-group",
		hoverClass: "hover",
		focusClass: "focus",
		openClass: "open"
	});
	$('a.sub-nav').removeClass('sub-nav');

	$(window).scroll(function () {
		//only for desktop
		if ($("#mobile-nav").css("display") == "none") {
			//hide header on scroll past 300px
			var sliderHeight = $('.intBanner').height();
			var headerHeight = 154;
	        var distanceY = window.pageYOffset || document.documentElement.scrollTop;
	        var shrinkOn = (sliderHeight - headerHeight);
	        var header = $("#nav-container");
	        if (distanceY > shrinkOn) {
	        	//$("#top-nav").attr('style', 'position: absolute;');
	            header.addClass("smaller");
	        } else {
				//$("#top-nav").removeAttr("style");
	            header.removeClass("smaller");
	        }

		    // variable opacity based on how far down we have scrolled
		    var opacityMin = 0.6;
		    var opacityMax = 1;
		    var bottomBoundary = sliderHeight - headerHeight;
		    var percentScrolled = distanceY / bottomBoundary;
		    var opacity = ((opacityMax - opacityMin) * percentScrolled) + opacityMin;
		    if (opacity > opacityMax) opacity = opacityMax;
		    if (opacity < opacityMin) opacity = opacityMin;
		    var divStyle = 'background: rgba(0, 0, 0, '+opacity+');';
		    $("#nav-container").attr('style', divStyle);
		    $("#nav-container .before").attr('style', divStyle);
		    $("#nav-container .after").attr('style', divStyle);
		} else {
			//remove header style
			$("#nav-container").removeAttr("style");
		}
	});
}); //End document.ready

window.onload = function() {
	// executes when complete page is fully loaded, including all frames, objects and images
}; //End window.onload

function html5FormCompatibility() {
}

//Google Analytics Event Tracking
//https://developers.google.com/analytics/devguides/collection/analyticsjs/events
function trackEvent(category, action, label) {
  //EXAMPLES:
	//ga('send', 'event', 'Videos', 'Play', 'Gone With the Wind']);
	//ga('send', 'event', 'Videos', 'Downloaded', 'Gone With the Wind']);
	//ga('send', 'event', 'Downloads', 'PDF', 'Expense Report']);
	//ga('send', 'event', 'datasheet-download', 'click', 'http://www.myurl.com');
	//console.log('tracking: category = '+category+', action = '+action+', label = '+label);
	ga('send', 'event', category, action, label);
}

function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
	$(clickedElm).click(function(event) {
		event.preventDefault();
		$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
		return false;
	});
}

function getScrollbarWidth() {
	var outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	document.body.appendChild(outer);

	var widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	var inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	var widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	return widthNoScroll - widthWithScroll;
}

/*
 * jQuery getCSS Plugin
 * Copyright 2013, intesso
 * MIT license.
 *
 * cross browser function to dynamically load an external css file.
 * see: [github page](http://intesso.github.com/jquery-getCSS/)
 *
 */

(function() {
	/*
		arguments: attributes
		attributes can be a string: then it goes directly inside the href attribute.
		e.g.: $.getCSS("fresh.css")
		attributes can also be an objcet.
		e.g.: $.getCSS({href:"cool.css", media:"print"})
		or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
	*/
	var getCSS = function(attributes) {
			// setting default attributes
			if(typeof attributes === "string") {
				var href = attributes;
				attributes = {
					href: href
				};
			}
			if(!attributes.rel) {
				attributes.rel = "stylesheet";
			}
			// appending the stylesheet
			// no jQuery stuff here, just plain dom manipulations
			var styleSheet = document.createElement("link");
			for(var key in attributes) {
				styleSheet.setAttribute(key, attributes[key]);
			}
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(styleSheet);
		};

	if(typeof jQuery === "undefined") {
		window.getCSS = getCSS;
	} else {
		jQuery.getCSS = getCSS;
	}

})();